import { createSlice } from "@reduxjs/toolkit";

const initialState: Record<string, string | number | Array<string> | null> = {
  from: "",
  fromStr: "",
  to: "",
  toStr: "",
  duration: "24",
  jobEnv: "prd",
  jobStatus: "",
  division: "",
  platform: "",
  name: "",
  dryRun: "",
  jobID: "",
  divisionFilters: [],
  typeFilters: [],
  initJobList: [],
  jobLastEvaulateKey: null,
  initPublishJobList: [],
  publishJobLastEvaulateKey: null
};

const jobFilterSlice = createSlice({
  name: "jobFilter",
  initialState: initialState,
  reducers: {
    updateJobFilter: (state, action: { payload: { type: string; value: string } }) => {
      state[action.payload.type] = action.payload.value;
    },
    updateDivisionFilter: (state, action: { payload: { value: [] } }) => {
      state.divisionFilters = action.payload.value;
    },
    updateTypeFilter: (state, action: { payload: { value: [] } }) => {
      state.typeFilters = action.payload.value;
    }
  }
});

export const { updateJobFilter, updateDivisionFilter, updateTypeFilter } = jobFilterSlice.actions;

export default jobFilterSlice.reducer;
